import { FormField, SelectProps, Select } from '@amzn/awsui-components-react'
import { SERVICE_SELECTION_VALIDATION } from '../../Constant'
import { NewServiceProject } from './projectUtil'
import { useCallback, useEffect, useState } from 'react'
import { useAppContext } from '../../../context'
import useStore from '../../Store'
import _ from 'lodash'

interface CreateProjectTableServiceNameProps {
    item: NewServiceProject
    selectedYear: number
    onNewProjectChange: (id: string, type: string, value: any) => void
}

const CreateProjectTableServiceName = (props: CreateProjectTableServiceNameProps) => {
    const { item, selectedYear, onNewProjectChange } = props
    const [servicesLoading, setServicesLoading] = useState<boolean>(true)
    const [servicesOptions, setServicesOptions] = useState<SelectProps.Option[] | null>(null)

    const appContext = useAppContext()
    const apiClient = appContext.apiClient
    const selectBusinessEntity = useStore((state) => state.selectBusinessEntity)

    const getServices = useCallback(() => {
        apiClient
            .get(`/all-services/${selectedYear}/business-entity/${selectBusinessEntity.id}`)
            .then((res) => {
                const services = JSON.parse(res.data?.body)?.items
                setServicesOptions(generateDropDownOptions(services))
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                setServicesLoading(false)
            })
    }, [selectedYear, selectBusinessEntity.id])

    const generateDropDownOptions = (services) => {
        return services
            .map((service) => {
                const group = {
                    label: service.serviceName,
                    options: [],
                }
                const subOptions = service.discreteServices.map((discrete) => {
                    const disableSubOption = !discrete.isActive
                    const subOptions = {
                        label: discrete.serviceName,
                        disabled: disableSubOption,
                        disabledReason: disableSubOption
                            ? 'Cannot create a service project from an inactive service.'
                            : '',
                        value: discrete.serviceId,
                        data: discrete,
                    }
                    if (disableSubOption) {
                        subOptions['iconName'] = 'status-stopped'
                    }
                    return subOptions
                })
                if (!_.isEmpty(subOptions)) {
                    group.options = subOptions.sort((a, b) => a.label.localeCompare(b.label))
                }
                return group
            })
            .sort((a, b) => a.label.localeCompare(b.label))
    }

    useEffect(() => {
        getServices()
    }, [])

    return (
        <FormField errorText={item.serviceIdError}>
            <Select
                selectedOption={
                    servicesLoading ? null : { label: item.projectName, value: item.serviceId }
                }
                filteringType='auto'
                expandToViewport
                onChange={({ detail }: any) => {
                    const errorMessage =
                        detail.selectedOption.value === '' ? SERVICE_SELECTION_VALIDATION : ''
                    onNewProjectChange(item.projectId, 'serviceIdError', errorMessage)
                    onNewProjectChange(item.projectId, 'serviceId', detail.selectedOption.value)
                    onNewProjectChange(item.projectId, 'projectName', detail.selectedOption.label)
                    onNewProjectChange(
                        item.projectId,
                        'description',
                        detail.selectedOption.data?.description,
                    )
                    onNewProjectChange(
                        item.projectId,
                        'isActive',
                        detail.selectedOption.data?.isActive,
                    )
                }}
                onBlur={() => {
                    if (item.serviceId === '') {
                        onNewProjectChange(
                            item.projectId,
                            'serviceIdError',
                            SERVICE_SELECTION_VALIDATION,
                        )
                    }
                }}
                options={servicesOptions ?? []}
                placeholder='Choose a service'
                empty={`No available ${selectedYear} services`}
                loadingText={`Loading ${selectedYear} services`}
                statusType={
                    servicesLoading ? 'loading' : servicesOptions === null ? 'error' : 'finished'
                }
            />
        </FormField>
    )
}

export default CreateProjectTableServiceName
